/**
 * Item action mappings and outsourcing have product selections that need to be updated based on the form changes
 * when an option has been changed.
 */
function populateItemActions(){
    let actionOptions = populateItemActionOptions();
    populateOutsourcing(actionOptions['outsourcing']);

    // we decided to not move items, so no need to populate (keeping code for now)
    // populateItemActionMappings(actionOptions);
}

function populateOutsourcing(outsourcingOptions){
    $('.outsourcing-product').each(function(){
        addItemActionOptions($(this), outsourcingOptions);
    });
}

function populateItemActionMappings(actionOptions){
    let shouldHideMappingContainer = true;
    $('.item-action-mappings').each(function(){
        let options = getMappingOptions($(this), actionOptions);
        addItemActionOptions($(this), options);
        if($(this).val() === ''){
            shouldHideMappingContainer = false;
            $(this).parents('.form-group').show();
        }
        else
            $(this).parents('.form-group').hide();
    });

    if(shouldHideMappingContainer)
        $('#itemActionMappingContainer').hide();
    else
        $('#itemActionMappingContainer').show();
}

/**
 * actionOptions are the item actions with the options that can be selected for that action.  An option may be in multiple
 * actions.  However, we do not want to display duplicate options in the select, so this function will get the unique options
 * from the actions for the select.
 *
 * @param select
 * @param actionOptions
 */
function getMappingOptions(select, actionOptions){
    let optionsAdded = [];
    let options = [];

    if(select.data('hasprinting') === 1){
        for(const actionOption of actionOptions['printing']){
            if(!optionsAdded.includes(actionOption.productNodeID)){
                optionsAdded.push(actionOption.productNodeID);
                options.push(actionOption);
            }
        }
    }

    if(select.data('hascutting') === 1){
        for(const actionOption of actionOptions['cutting']){
            if(!optionsAdded.includes(actionOption.productNodeID)){
                optionsAdded.push(actionOption.productNodeID);
                options.push(actionOption);
            }
        }
    }

    if(select.data('hassewing') === 1){
        for(const actionOption of actionOptions['sewing']){
            if(!optionsAdded.includes(actionOption.productNodeID)){
                optionsAdded.push(actionOption.productNodeID);
                options.push(actionOption);
            }
        }
    }

    if(select.data('hasshipping') === 1){
        for(const actionOption of actionOptions['shipping']){
            if(!optionsAdded.includes(actionOption.productNodeID)){
                optionsAdded.push(actionOption.productNodeID);
                options.push(actionOption);
            }
        }
    }

    if(select.data('hasscheduling') === 1){
        for(const actionOption of actionOptions['scheduling']){
            if(!optionsAdded.includes(actionOption.productNodeID)){
                optionsAdded.push(actionOption.productNodeID);
                options.push(actionOption);
            }
        }
    }

    if(select.data('hasoutsourcing') === 1){
        for(const actionOption of actionOptions['outsourcing']){
            if(!optionsAdded.includes(actionOption.productNodeID)){
                optionsAdded.push(actionOption.productNodeID);
                options.push(actionOption);
            }
        }
    }

    return options;
}

function addItemActionOptions(select, options){
    let selectedProductNodeID   = select.val();
    let selectedName            = select.children('option').filter(':selected').text();
    let componentID             = select.data('componentid');
    let bundleGroupID           = select.data('bundlegroupid');
    let html                    = '<option value="">Select...</option>';

    /*
     * There are four cases where a selection should be made.  It's also possible that two or more of these cases exist
     * for different options.  We'll choose the option in this order:
     *
     * 1.  there is only one option
     * 2.  previously selected value (compare productNodeID)
     * 3.  matching componentID and bundleGroupID
     * 4.  matching name (the option text)
     */
    let selectedValue       = null;
    let previouslySelected  = null;
    let matchingIDs         = null;
    let matchingName        = null;
    for(const option of options){
        if(options.length === 1)
            selectedValue = option.productNodeID;
        if(selectedProductNodeID === option.productNodeID)
            previouslySelected = selectedProductNodeID;
        else if(previouslySelected === null && componentID === option.componentID && bundleGroupID === option.bundleGroupID)
            matchingIDs = option.productNodeID;
        else if(previouslySelected === null && option.name === selectedName)
            matchingName = option.productNodeID;

        html += createItemActionOption(option);
    }


    if(selectedValue === null && previouslySelected !== null)
        selectedValue = previouslySelected;
    else if(selectedValue === null && matchingIDs !== null)
        selectedValue = matchingIDs;
    else if(selectedValue === null && matchingName !== null)
        selectedValue = matchingName;

    select.html('').append(html);
    if(selectedValue !== null)
        select.val(selectedValue);
}

function populateItemActionOptions(){
    let options = {
        'outsourcing': [],
        'sewing': [],
        'cutting': [],
        'printing': [],
        'shipping': [],
        'scheduling': [],
    };

    let productRoot = $('.product-root');
    options = addItemActionOption(productRoot.data('name'), productRoot, options);
    options = populateProductSelectionOptions(options);

    return populateSingleProductOptions(options);
}

function populateProductSelectionOptions(itemActions){
    $('.product-selection').each(function(){
        let productNodeID = $(this).val();
        if($(this).data('isproduct') === 'yes' && productNodeID !== '' && isOptionActive($(this))) {
            let name = $(this).children('option').filter(':selected').text();
            itemActions = addItemActionOption(name, $(this), itemActions)
        }
    });

    return itemActions;
}

function populateSingleProductOptions(itemActions){
    $('.product-single').each(function(){
        if($(this).data('isproduct') === 'yes' && isOptionActive($(this).closest('.option-set'))) {
            let name = $(this).data('name');

            itemActions = addItemActionOption(name, $(this), itemActions);
        }
    });

    return itemActions;
}

function addItemActionOption(name, option, itemActions){
    let productNodeID   = option.val();
    let componentID     = option.data('componentid');
    let bundleGroupID   = option.data('bundlegroupid');

    let data = {
        productNodeID: productNodeID,
        componentID: componentID,
        bundleGroupID: bundleGroupID,
        name: name
    };

    if(option.data('canbeoutsourced') === 'yes')
        itemActions['outsourcing'].push(data);

    if(option.data('canbeprinted') === 'yes')
        itemActions['printing'].push(data);

    if(option.data('canbesewing') === 'yes')
        itemActions['sewing'].push(data);

    if(option.data('canbecut') === 'yes')
        itemActions['cutting'].push(data);

    if(option.data('canbeshipped') === 'yes')
        itemActions['shipping'].push(data);

    if(option.data('canbescheduled') === 'yes')
        itemActions['scheduling'].push(data);

    return itemActions;
}

function createItemActionOption(option){
    return '<option value="' + option.productNodeID + '">' + option.name + '</option>';
}

/**
 * Only product options that are active should be added to outsourcing products.  Sometimes the form is hidden, such as
 * edit multiple, which means that is(:visible) check does not work in those cases.  An option is active as long as no
 * ancestor fieldset is hidden.  The element may be a product selection or an option set.
 *
 * We need to check the element itself and each of its fieldset ancestors.
 */
function isOptionActive(element){
    if(element.css('display') === 'none')
        return false;

    let isActive = true;
    element.parents('fieldset').each(function(){
       if($(this).css('display') === 'none')
           isActive = false;
    });

    return isActive;
}